export const ALL_IN_ONE_STEPS = [
  { label: 'recipeSteps.indication', id: 'indication' },
  { label: 'recipeSteps.measureColor', id: 'measurement' },
  { label: 'recipeSteps.getRecipe', id: 'recipe' },
]

export enum DENTIN_TYPE {
  SINGLE_DENTIN = 'single dentin',
  TRIPLE_DENTIN = 'triple dentin',
}

export const INDICATION_FORM = {
  recipeType: {
    label: 'allInOne.indication.recipeType.label',
    tooltip: 'allInOne.indication.recipeType.tooltip',
    options: [
      {
        value: 'single dentin',
        label: 'allInOne.indication.recipeType.options.single',
      },
      {
        value: 'triple dentin',
        label: 'allInOne.indication.recipeType.options.triple',
      },
    ],
  },
  indication: {
    title: 'allInOne.indication.indication.title',
    tooltip: 'allInOne.indication.indication.tooltip',
  },
}

export const PFM_CROWN_INDICATION = 'PFM Crown'

// yup's `when` passes the watched value wrapped in an array.
export const isPfmIndication = (indication?: unknown) =>
  [indication].flat().includes(PFM_CROWN_INDICATION)

// Offered by the metadata but rejected by the server (422 "Coming soon").
export const HIDDEN_INDICATIONS = [
  'Crown Labial cutback',
  'Full Monolithic Crown',
]

export enum COLOR_VALUE {
  LabColor = 'l*a*b Color',
  Vita3DMaster = 'VITA3D Master',
  VitaClassic = 'VITA Classic',
  NaturalDieMaterial = 'Natural Die Material',
}

export const PREP_DENTIN_DROPDOWN_OPTIONS = [
  { value: COLOR_VALUE.LabColor, text: COLOR_VALUE.LabColor },
  { value: COLOR_VALUE.Vita3DMaster, text: COLOR_VALUE.Vita3DMaster },
  { value: COLOR_VALUE.VitaClassic, text: COLOR_VALUE.VitaClassic },
]

export const PREP_DROPDOWN_OPTIONS = [
  { value: COLOR_VALUE.LabColor, text: COLOR_VALUE.LabColor },
  { value: COLOR_VALUE.Vita3DMaster, text: COLOR_VALUE.Vita3DMaster },
  { value: COLOR_VALUE.VitaClassic, text: COLOR_VALUE.VitaClassic },
  {
    value: COLOR_VALUE.NaturalDieMaterial,
    text: COLOR_VALUE.NaturalDieMaterial,
  },
]

export const MATERIAL_TEXT = {
  ceramicBrands: {
    title: 'allInOne.material.ceramicBrands.title',
    tooltip: 'allInOne.material.ceramicBrands.tooltip',
  },
  aestheticModel: {
    title: 'allInOne.material.aestheticModel.title',
    tooltip: 'allInOne.material.aestheticModel.tooltip',
  },
  framework: {
    title: 'allInOne.material.framework.title',
    tooltip: 'allInOne.material.framework.tooltip',
  },
  opaquerBrand: {
    title: 'allInOne.material.opaquerBrand.title',
    tooltip: 'allInOne.material.opaquerBrand.tooltip',
  },
  frameworkStaining: {
    title: 'allInOne.material.frameworkStaining.title',
    tooltip: 'allInOne.material.frameworkStaining.tooltip',
  },
  availableSpace: {
    title: 'allInOne.material.availableSpace.title',
    tooltip: 'allInOne.material.availableSpace.tooltip',
  },
}

export const COLOR_MEASUREMENT_TEXT = {
  preparationColor: {
    title: 'allInOne.colorMeasurement.preparationColor.title',
    tooltip: 'allInOne.colorMeasurement.preparationColor.tooltip',
  },
  dentinColor: {
    title: 'allInOne.colorMeasurement.dentinColor.title',
    tooltip: 'allInOne.colorMeasurement.dentinColor.tooltip',
  },
  skinEnamelType: {
    title: 'allInOne.colorMeasurement.skinEnamelType.title',
    tooltip: 'allInOne.colorMeasurement.skinEnamelType.tooltip',
  },
}

export const imageType = {
  OPTISHADE: 'optishade',
  RAW: 'raw',
  IMAGE: 'image',
  PHOTO: 'photo',
}

interface Option {
  order: number
  [key: string]: any
}

export const getOptions = (metadata: Record<string, any>, key: string) =>
  metadata?.[key as keyof typeof metadata]
    ?.flat()
    ?.sort((a: Option, b: Option) => a.order - b.order)
